let store = {
  namespaced: true,
  state: {
    hide: true
  },
  mutations: {
    show (state) {
      state.hide = false
    },
    hide (state) {
      state.hide = true
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/nav.js